import React, { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Drawer, Tab, Tabs } from "@mui/material";
import styles from "./NotesDrawer.module.css";
import ListViewTasksTab from "../../../../components/ListTab/ListViewTasksTab";
import LeadNotesTab from "../../../../components/ListTab/LeadNotesTab";
import { useSelector } from "react-redux";
import {
  resetDeleteNoteSuccess,
  resetDeleteTaskSuccess,
  resetEditNoteSuccess,
  resetEditTaskSuccess,
  resetNoteSuccess,
  resetTaskSuccess,
} from "../service/nurtureSlice";
import { useDispatch } from "react-redux";
import TaskTabSideDrawer from "./TaskTabSideDrawer";

function NotesTaskDrawer(props: any) {
  const {
    setDrawerModal,
    openDrawerModal,
    activeTab,
    setActiveTab,
    CreateTask,
    EditTask,
    DeleteTask,
    UpdateTaskStatus,
    selectedLeadData,
    leadTaskList,
    employees,
    taskTypes,
    CreateNote,
    EditNote,
    DeleteNote,
    leadNoteList,
    GetLeadTaskList,
    GetLeadNoteList,
  } = props;
  const [loader, setLoader] = useState(false);

  const { createTaskSuccess, editTaskSuccess, deleteTaskSuccess } = useSelector(
    (state: any) => state.nurture
  );
  const dispatch = useDispatch();
  const { editNoteSuccess, createNoteSuccess, deleteNoteSuccess } = useSelector(
    (state: any) => state.nurture
  );
  const taskStatusUpdateSuccess = useSelector(
    (state: any) => state.tasks.taskStatusUpdateSuccess
  );

  React.useEffect(() => {
    if (
      (createTaskSuccess !== true && createTaskSuccess !== false) ||
      (editTaskSuccess !== true && editTaskSuccess !== false) ||
      (deleteTaskSuccess !== true && deleteTaskSuccess !== false) ||
      (taskStatusUpdateSuccess !== true && taskStatusUpdateSuccess !== false)
    ) {
      // GetLeadTaskList(selectedLeadData?.id);
      dispatch(resetTaskSuccess());
      dispatch(resetEditTaskSuccess());
      dispatch(resetDeleteTaskSuccess());
      setDrawerModal(false);
    }
  }, [
    createTaskSuccess,
    editTaskSuccess,
    deleteTaskSuccess,
    taskStatusUpdateSuccess,
  ]);

  React.useEffect(() => {
    if (
      (createNoteSuccess !== true && createNoteSuccess !== false) ||
      (editNoteSuccess !== true && editNoteSuccess !== false) ||
      (deleteNoteSuccess !== true && deleteNoteSuccess !== false)
    ) {
      // GetLeadNoteList(selectedLeadData?.id);
      dispatch(resetNoteSuccess());
      dispatch(resetDeleteNoteSuccess());
      dispatch(resetEditNoteSuccess());
      setDrawerModal(false);
    }
  }, [createNoteSuccess, deleteNoteSuccess, editNoteSuccess]);

  useEffect(() => {
    setLoader(true);
    setActiveTab(0);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, []);

  return (
    <div>
      <Drawer
        className="filter_drawer"
        anchor="right"
        open={openDrawerModal}
        onClose={() => setDrawerModal(false)}
        PaperProps={{
          sx: {
            width: 450,
            backgroundColor: "#ffff",
            zIndex: "999999",
          },
        }}
      >
        <button
          className={styles.filterCloeBtn}
          onClick={() => {
            setDrawerModal(false);
          }}
        >
          x
        </button>
        <Box
          sx={{
            margin: "10px",
            borderBottom: "1px solid #E9E9E9",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
          >
            <Tab label="Tasks" />
            <Tab label="Notes" />
          </Tabs>
        </Box>

        {loader ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={18} color={"inherit"} />
          </div>
        ) : (
          <>
            {activeTab === 0 && (
              <TaskTabSideDrawer
                CreateTask={CreateTask}
                EditTask={EditTask}
                DeleteTask={DeleteTask}
                UpdateTaskStatus={UpdateTaskStatus}
                selectedLeadData={selectedLeadData}
                leadTaskList={leadTaskList}
                employees={employees}
                taskTypes={taskTypes}
              />
            )}
            {activeTab === 1 && (
              <LeadNotesTab
                CreateNote={CreateNote}
                EditNote={EditNote}
                DeleteNote={DeleteNote}
                selectedLeadData={selectedLeadData}
                leadNoteList={leadNoteList}
                employees={employees}
              />
            )}
          </>
        )}
      </Drawer>
    </div>
  );
}

export default NotesTaskDrawer;
